var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#1778F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88605 2.72925L8.64823 2.72726C7.25758 2.72726 6.35889 3.6493 6.35889 5.07639V6.15949H5.11431C5.00677 6.15949 4.91968 6.24668 4.91968 6.35423V7.92352C4.91968 8.03107 5.00687 8.11816 5.11431 8.11816H6.35889V12.078C6.35889 12.1855 6.44597 12.2726 6.55352 12.2726H8.17733C8.28488 12.2726 8.37197 12.1854 8.37197 12.078V8.11816H9.82716C9.93471 8.11816 10.0218 8.03107 10.0218 7.92352L10.0224 6.35423C10.0224 6.30259 10.0018 6.25314 9.96539 6.21659C9.92895 6.18005 9.8793 6.15949 9.82766 6.15949H8.37197V5.24133C8.37197 4.80003 8.47713 4.576 9.052 4.576L9.88585 4.5757C9.9933 4.5757 10.0804 4.48851 10.0804 4.38107V2.92389C10.0804 2.81654 9.9934 2.72945 9.88605 2.72925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.54545,
    height: 9.54536,
    fill: "white",
    transform: "translate(2.72729 2.72726)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.a0a46b2c39115a55a6ee86497c7f9bce.svg";
export { ForwardRef as ReactComponent };